<template>
	<div>
		<div class="row content-header">
			<div class="content-header-left mb-2 col-md-9 col-12">
				<div class="row breadcrumbs-top">
					<div class="col-12">
						<h2 class="content-header-title float-left pr-1 mb-0">Litter Sale</h2>
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item active">
									<span aria-current="location"> Add </span>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
		</div>
		<validation-observer ref="simpleRules">
			<b-form method="post" @submit="addLitterSale">
				<b-card>
					<b-row>
						<b-col md="6">
							<b-form-group label="Flock ID" label-for="flock-id">
								<validation-provider #default="{ errors }" name="Flock ID" rules="required">
									<v-select
										id="flock-id"
										v-model="FormData.flock_id"
										:clearable="false"
										label="flock_id"
										:options="flockDataList"
										:reduce="(e) => e.flock_id"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group label="Sold To" label-for="source">
								<validation-provider #default="{ errors }" name="Sold To" rules="required">
									<v-select
										id="source"
										v-model="FormData.source_id"
										:clearable="false"
										label="name"
										:options="sourceList"
										:reduce="(e) => e.id"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>
						<b-col md="4">
							<b-form-group label="Litter Sold (Quantity)" label-for="quantity">
								<validation-provider #default="{ errors }" name="Quantity" rules="required">
									<b-form-input
										id="quantity"
										v-model="FormData.quantity"
										placeholder="Quantity"
										type="number"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>
						<b-col md="4">
							<b-form-group label="Unit Cost (Rs.)" label-for="unit-cost">
								<validation-provider #default="{ errors }" name="Unit Cost" rules="required">
									<b-form-input
										id="unit-cost"
										v-model="FormData.unit_cost"
										placeholder="Unit Cost (Rs.)"
										type="number"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>
						<b-col md="4">
							<b-form-group label="Weight (Kg)" label-for="weight">
								<b-form-input
									id="weight"
									v-model="FormData.weight"
									placeholder="Weight (Kg) — optional"
									type="number"
								/>
							</b-form-group>
						</b-col>
						<b-col md="4">
							<b-form-group label="Total Sale Cost (Rs.)" label-for="total-cost">
								<b-form-input id="total-cost" :value="totalCost" placeholder="Total Sale Cost" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<!-- submit and reset -->
					<b-col>
						<b-button type="submit" variant="primary" value="Submit" class="mr-1"> Submit </b-button>
					</b-col>
				</b-card>
			</b-form>
		</validation-observer>
	</div>
</template>

<script>
import vSelect from "vue-select";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axiosIns from "@/libs/axios";

export default {
	components: {
		vSelect,
		ValidationProvider,
		ValidationObserver,
	},

	data() {
		return {
			required,
			farmId: null,
			flockDataList: [],
			sourceList: [],
			FormData: {
				flock_id: null,
				source_id: null,
				quantity: null,
				unit_cost: null,
				weight: null,
			},
		};
	},
	computed: {
		totalCost() {
			const quantity = parseFloat(this.FormData.quantity);
			const unitCost = parseFloat(this.FormData.unit_cost);
			if (!quantity || !unitCost) return "";
			return (quantity * unitCost).toFixed(2);
		},
	},
	created() {
		this.farmId = this.$route.params.farmId;
		this.getFlockList();
		this.getSource();
	},
	methods: {
		getFlockList() {
			axiosIns
				.get(`web/farm/${this.farmId}/flock-list`)
				.then((response) => {
					this.flockDataList = response.data.flock_list;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
		getSource() {
			axiosIns
				.get(`web/get-all-sources`)
				.then((response) => {
					this.sourceList = response.data.source_list;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
		addLitterSale(e) {
			e.preventDefault();
			this.$refs.simpleRules.validate().then((success) => {
				if (success) {
					const flockId = this.FormData.flock_id;
					var data = new FormData();
					data.append("sale_type", "litter");
					data.append("source_id", this.FormData.source_id);
					data.append("quantity", this.FormData.quantity);
					data.append("unit_cost", this.FormData.unit_cost);
					if (this.FormData.weight) data.append("weight", this.FormData.weight);

					axiosIns
						.post(`web/farm/${this.farmId}/flock/${flockId}/sales`, data)
						.then(() => {
							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "success",
									text: `Litter sale successfully added`,
								},
							});
							this.$router.push({ name: "co-apps-sale-litter-sale" });
						})
						.catch((error) => {
							const data = error.response?.data?.errors;
							const message = data
								? Object.values(data).flat().toString(",")
								: error.response?.data?.message || "Failed to add litter sale, try again.";
							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "danger",
									text: message,
								},
							});
						});
				}
			});
		},
	},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
</style>
